module.exports = __webpack_public_path__ + "img/位图.d2ff2548.png";